import { createSlice } from "@reduxjs/toolkit";
import initialState from "./initialState";
import { fetchUser } from "./thunks";
import { initialApiState } from "../common";

const userSlice = createSlice({
  name: "userSlice",
  initialState,
  reducers: {
    logoutUser: (state) => {
      state.isUserLoggedIn = false;
    },
    setUserLoggedIn: (state) => {
      state.isUserLoggedIn = true;
    },
    setCronApiKeyState: (state, action) => {
      if (state.userData?.data?.config?.isCronJobKeySetup)
        state.userData.data.config.isCronJobKeySetup = action.payload;
    },
    setNotificationsEnabledForDevice: (state, action) => {
      if (state.userData?.data?.config) {
        const deviceSet = new Set(
          state.userData.data.config.notificationDevices || []
        );
        deviceSet.add(action.payload);
        state.userData.data.config.notificationDevices = [...deviceSet];
      }
    },
    setNotificationsDisabledForDevice: (state, action) => {
      if (state.userData?.data?.config) {
        const deviceSet = new Set(
          state.userData.data.config.notificationDevices || []
        );
        deviceSet.delete(action.payload);
        state.userData.data.config.notificationDevices = [...deviceSet];
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUser.pending, (state, _action) => {
      state.userData.state = "pending";
      state.userData.error = null;
    });
    builder.addCase(fetchUser.fulfilled, (state, action) => {
      state.userData.state = "success";
      state.userData.data = action.payload;
      state.userData.error = null;
    });
    builder.addCase(fetchUser.rejected, (state, action) => {
      state.userData.state = "failed";
      state.userData.data = null;
      state.userData.error = action.error;
    });
    builder.addCase("common/cleanup", (state, _action) => {
      state.userData = initialApiState;
      state.lastSync = "";
    });
  },
});

export default userSlice.reducer;
export const {
  logoutUser,
  setUserLoggedIn,
  setCronApiKeyState,
  setNotificationsEnabledForDevice,
  setNotificationsDisabledForDevice,
} = userSlice.actions;
